import type {
  IPayoutMethodBankDetails,
  IPayoutMethodUPI,
  PayoutMethodType,
} from "../../../../../types/models/payout-transaction.modals.types";
import type { IPAN } from "../../../../../types/models/vendor.modals.types";
import { usePostHttp } from "../../../http.hook";

export interface IPayoutMethod {
  id: string;
  payoutMethodType: PayoutMethodType;
  bankAccountDetails: IPayoutMethodBankDetails | null;
  upiDetails: IPayoutMethodUPI | null;
  isVerified: boolean;
  pan: IPAN | null;
  name: string;
}

interface IResponse {
  payoutMethod: IPayoutMethod;
}

export function useAddBankAccountHttp() {
  return usePostHttp<IPayoutMethodBankDetails, IResponse>({
    path: "/admin/vendors/payouts/:vendorId/add-bank-account",
  });
}
